export default __webpack_public_path__ + "static/media/MASTER-MIND.11926764.png";